import { useCallback, useEffect, useState } from "react";

import BackEndService from "../api/BackEndService";
import MonitorService from "../api/MonitorService";
import { Comment } from "../types/comment";

const useTraplinkedReportComments = (monitorId: string, reportId?: string, propertyAreaId?: string) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [loadingComments, setLoadingComments] = useState(false);

  const fetchComments = useCallback(async () => {
    if (monitorId) {
      setLoadingComments(true);
      try {
        const { data } =
          await MonitorService.GetMonitorById(monitorId, propertyAreaId);
          const report = data?.traplinkedReports?.find(
            (r: any) => r.id === reportId
          );
      
          setComments(report?.comments ?? []);
        
      } catch (error) {
        console.error("Error fetching comments:", error);
      } finally {
        setLoadingComments(false);
      }
    }
  }, [monitorId]);

  const addComment = async (content: string) => {
    if (!monitorId || !reportId) return;

    try {
      await BackEndService.AddComment({
        content,
        attachedTo: { type: "TraplinkedDeviceReport", id: reportId },
      });
      fetchComments();
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [fetchComments]);

  return { comments, loadingComments, fetchComments, addComment };
};

export default useTraplinkedReportComments;
